import { inject } from '@angular/core';
import { Router, CanActivateFn } from '@angular/router';
import { MsalService } from '@azure/msal-angular';
import { map, take, switchMap, timeout, catchError } from 'rxjs/operators';
import { of } from 'rxjs';

export const authGuard: CanActivateFn = (route, state) => {
  const msalService = inject(MsalService);
  const router = inject(Router);

  // Wait for MSAL to initialize, then check for active account
  return msalService.initialize().pipe(
    take(1),
    switchMap(() => {
      // Check if there's an active account
      let activeAccount = msalService.instance.getActiveAccount();

      // If no active account, try to set one from stored accounts
      if (!activeAccount) {
        const accounts = msalService.instance.getAllAccounts();
        if (accounts.length > 0) {
          msalService.instance.setActiveAccount(accounts[0]);
          activeAccount = accounts[0];
        }
      }

      return of(activeAccount);
    }),
    timeout(5000), // 5 second timeout
    catchError(() => of(null)),
    map(account => {
      if (account) {
        return true;
      } else {
        // Redirect to home page if not authenticated
        router.navigate(['/']);
        return false;
      }
    })
  );
};

